export default __webpack_public_path__ + "static/features-panel0-c83bc376e1b8f1639336848d9caeb03e.png";